import { FC, ReactElement } from 'react';
import { NavLink } from 'react-router';
import { NavItemProps } from '../utils/constants/NavItem.interface';
import { Close } from '@mui/icons-material';

const TabItem: FC<NavItemProps> = ({
  label,
  variant = 'primary',
  testId = '',
  isDismissible = false,
  onDismiss,
  ...rest
}): ReactElement<any> => {
  return (
    <NavLink
      {...rest}
      data-testid={testId}
      className={({ isActive }) =>
        `pa-24-horizontal fw4 fs-16 lh-21 flex h-40 items-center no-underline ${
          variant === 'primary' ? 'br b--athens-gray' : ''
        } ${
          variant === 'primary'
            ? isActive
              ? 'tints-default-ultra-light bg-shade-default'
              : 'shade-default bg-tints-default-light'
            : ''
        } ${
          variant === 'secondary'
            ? isActive
              ? 'bg-tints-default-ultra-light shade-default'
              : 'tints-default-ultra-light bg-transparent'
            : ''
        }`
      }
    >
      {({ isActive }) => (
        <>
          {label}

          {isDismissible && (
            <button
              data-testid="clear-input"
              type="button"
              className="tw:cursor-pointer tw:border-0 tw:justify-center tw:items-center tw:pt-1.5 tw:bg-transparent"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (onDismiss) {
                  onDismiss();
                }
              }}
            >
              <Close
                fontSize="inherit"
                className={`tw:text-base ${isActive ? 'tw:text-white' : ''}`}
              />
            </button>
          )}
        </>
      )}
    </NavLink>
  );
};

export default TabItem;
